// extracted by mini-css-extract-plugin
export default {"root":"StudyBtn_root__5OxFP"};